export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="px-4 md:px-6 py-12 md:py-16 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-heading font-bold text-background-50 mb-4">911爆料网</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              国内领先的吃瓜黑料资讯聚合平台，聚焦911爆料、吃瓜黑料等热点内容，
              每日更新各类爆料事件与八卦资讯，提供网站最新地址与入口。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 flex items-center justify-center bg-background-700 rounded-lg text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center bg-background-700 rounded-lg text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center bg-background-700 rounded-lg text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-links-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">最新爆料</a></li>
              <li><a href="#cards" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">热门吃瓜</a></li>
              <li><a href="#media" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">精选视频</a></li>
              <li><a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">热度榜单</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">主题索引</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><a href="#about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">平台介绍</a></li>
              <li><a href="#features" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">平台特色</a></li>
              <li><a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">常见问题</a></li>
              <li><a href="#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">联系我们</a></li>
              <li><a href="#comments" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">网友热议</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              暂无具体合作伙伴信息，如有合作意向请联系我们。
            </p>
            <div className="mt-4">
              <h4 className="text-sm font-bold text-background-50 mb-2">联系方式</h4>
              <p className="text-sm text-background-400">邮箱：tips@911baoliao.com</p>
              <p className="text-sm text-background-400">微信：911baoliao_official</p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {currentYear} 911爆料网. All Rights Reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#hero" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
              <a href="#hero" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#hero" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}